import React from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { Label } from "./general";
import PhoneField from "./phone-input/PhoneField";
import { validatePhoneFormat } from "./phone-input/phoneNumber";
import {
  DEFAULT_PHONE_COUNTRY,
  REVALIDATE_TRIGGER,
} from "./phone-input/constants";

/**
 * Labelled phone field: country picker + number, stored as international digits
 * without the "+" ("966501234567") — the shape every phone column in the API
 * takes. Validates the number against the picked country's real numbering plan,
 * then runs `validatePhone` (a server-side check such as "already registered")
 * only once the number itself is valid.
 */
const SharedPhoneInput = ({
  name,
  label,
  required,
  requiredMessage,
  validatePhone,
  validateFormat = true,
  defaultCountry = DEFAULT_PHONE_COUNTRY,
  form: _form,
  ...rest
}) => {
  const { t } = useTranslation();

  const rules = [
    required && {
      required: true,
      message: requiredMessage || t("formItemRules.requiredMessage"),
    },
    validateFormat && {
      validator: (_, value) =>
        validatePhoneFormat(value, { defaultCountry, t }),
    },
    validatePhone && { validator: validatePhone },
  ].filter(Boolean);

  return (
    <div className="add-unit">
      {label && <Label required={required} title={label} />}

      <Form.Item
        name={name}
        rules={rules}
        validateFirst
        validateTrigger={["onBlur", REVALIDATE_TRIGGER]}
        hasFeedback
      >
        <PhoneField defaultCountry={defaultCountry} {...rest} />
      </Form.Item>
    </div>
  );
};

export default SharedPhoneInput;
